import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Alert } from 'antd';
import { LockOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { assets } from '../../assets';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { backendURL } from 'src/constant/api/backendURL';
import './signIn.scss';

export const ResetPassword = () => {
    const { id, token } = useParams<{ id: string, token: string }>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const onSubmit = async (values: any) => {
        if (values.password !== values.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');
        try {
            const response = await axios.post(`${backendURL}/auth/resetpassword/${id}/${token}`, { password: values.password });
            setSuccess(response.data.message || 'Password successfully reset.');
            setTimeout(() => {
                navigate('/signIn');
            }, 3000);
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to reset password. Link may be expired.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row gutter={16} className="auth-page-row" style={{ minHeight: '100vh' }}>
            <Col xs={0} sm={0} md={14} lg={14} className="auth-image-col">
                <div className="backgroundSignIn">
                    <img src={assets.signInSignUpBG} alt="" />
                </div>
            </Col>

            <Col xs={24} sm={24} md={10} lg={10} className="auth-form-col" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '90%' }}>
                    <Form
                        name="reset-password"
                        onFinish={onSubmit}
                        style={{ maxWidth: 350, margin: 'auto' }}
                    >
                        <Link to="/" className="navbar-logo" style={{ textDecoration: 'none', display: 'block', marginBottom: '30px' }}>
                            <img src={require('../../assets/images/The Pickers Stop LOGO.png')} alt="The Pickers Stop" style={{ maxHeight: '60px', width: 'auto' }} />
                        </Link>

                        <h2 style={{ marginBottom: '20px', fontFamily: 'var(--font-heading)' }}>Create New Password</h2>

                        <Form.Item name="password" rules={[{ required: true, message: 'Please input your new password!' }, { min: 6, message: 'Password must be at least 6 characters' }]}>
                            <Input.Password
                                size="large"
                                prefix={<LockOutlined className="site-form-item-icon" style={{ marginRight: '6px' }} />}
                                placeholder="New Password"
                            />
                        </Form.Item>

                        <Form.Item name="confirmPassword" rules={[{ required: true, message: 'Please confirm your new password!' }]}>
                            <Input.Password
                                size="large"
                                prefix={<LockOutlined className="site-form-item-icon" style={{ marginRight: '6px' }} />}
                                placeholder="Confirm New Password"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" size="large" htmlType="submit" style={{ width: '100%' }} disabled={loading}>
                                {loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: '14px' }} spin />} /> : 'Reset Password'}
                            </Button>
                        </Form.Item>

                        {success && <Alert type="success" showIcon message={success} style={{ marginBottom: '20px' }} />}
                        {error && <Alert type="error" showIcon message={error} style={{ marginBottom: '20px' }} />}

                        <div style={{ textAlign: 'center' }}>
                            <Link to="/signIn">Back to Sign In</Link>
                        </div>
                    </Form>
                </div>
            </Col>
        </Row>
    );
};
